import React from 'react'
import { Form } from 'react-bootstrap'


const InputComponent = ({
	control,
	description=null,
	disabled=false,
	errors,
	label=null,
	name,
	placeholder=null,
	type,
	register,
	required=true,
	value=null,
	...rest
}) => {

	return (
		<>

			<Form.Group className='mb-3'>
				{label && 
					<Form.Label
						className='mb-0'
						htmlFor={name}
					>{label}</Form.Label>
				}

				<Form.Control 
					className='form-control'
					disabled={disabled}
					defaultValue={value}
					id={name}
					name={name}
					placeholder={placeholder}
					type={type}
					{...register(name, {
						required: {
							value: required,
							message: 'Campo obrigatório'
						}
					})}
					{...rest}
				/>

				{description && 
					<Form.Text className="text-muted">{description}</Form.Text>
				}

				{errors[name] && <p className='mt-1 form-error'>{errors[name].message}</p>}				
			</Form.Group>

		</>
	)

}

export default InputComponent;
